
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/media-about-us",
      function () {
        return require("private-next-pages/about-us/media-about-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/media-about-us"])
      });
    }
  